
<template>

	<div>
	<b-overlay :show="wait">
		<mymodal ref="change_roles" title="Изменить роли" ok="Сохранить" :reset="reset" :submit="submit">
			<b-form-checkbox-group
				v-model="new_roles"
				:options="roles_options"
				value-field="value"
				text-field="text"
			/>
		</mymodal>

		<myframe title="Роли" expanded>

			<div>{{ roles }}</div>

			<ul>
				<li v-for="{ text, value } in roles_options.filter(role => roles.includes(role.value))" :key="value">{{ text }}</li>
			</ul>

			<b-button variant="primary" @click="() => $refs.change_roles.execute()">Изменить роли</b-button>

			<div class="mt-2">Статья: <v-select :value="article" :options="articles" v-on:input="set_article" :clearable="false" clearSearchOnSelect required appendToBody/></div>
			
			<b-button variant="primary" class="mt-2" @click="toggle_readonly">{{ $root.readonly ? 'Отключить' : 'Включить' }} "Режим чтения"</b-button>
		</myframe>

		<b-button size="sm" variant="primary" class="mt-2" v-on:click="() => download()">Скачать файл</b-button><br/>

		<b-button size="sm" variant="primary" class="mt-2" v-on:click="() => export_all()">Создать пакет экспорта</b-button><br/>

		<b-button size="sm" variant="primary" class="mt-2" v-on:click="() => export_everything()">Выгрузить реестры</b-button><br/>

		<myframe title="Разное" class="mt-2" expanded :visible="false">

			<b-button size="sm" variant="primary" class="mt-2" v-on:click="() => validation()">Валидация расчета</b-button><br/>
			<b-button size="sm" variant="danger" class="mt-2" v-on:click="() => backup_restore()">Восстановить БД</b-button><br/>
			<b-button size="sm" variant="danger" class="mt-2" v-on:click="() => disable_stated()">{{ $root.not_editable ? 'Отключить' : 'Включить' }} ст. 16</b-button><br/>

		</myframe>

		<myframe title="Ping" expanded>

			<b-button size="sm" variant="primary" class="mt-2" v-on:click="() => ping()">Ping</b-button><br/>

			{{ pong }}

		</myframe>

		<myframe title="Test" expanded>

			<b-button size="sm" variant="primary" class="mt-2" v-on:click="() => test()">Test</b-button><br/>

			{{ test_response }}

		</myframe>


		<!--
		<myframe title="Расчет по формуле" class="mt-2" expanded :visible="false">

			<b-row class="mt-2">

				<b-col cols="3">Формула:</b-col>
				<b-col><b-form-textarea v-model="formula" rows="5"/></b-col>

			</b-row>

			<b-row class="mt-2">

				<b-col cols="3">Параметры:</b-col>
				<b-col><b-form-textarea v-model="formula_params" rows="15"/></b-col>

			</b-row>

			<b-button :disabled="formula == null || formula == '' || formula_params == null || formula_params == ''" size="sm" variant="primary" class="mt-2" v-on:click="() => calculate()">Рассчитать</b-button><br/>

			<div class="mt-2">

				Перед запуском расчета проверьте:

				<ul>

					<li>скобки;</li>
					<li>кавычки в параметрах - ожидаем валидный JSON;</li>
					<li>наименование полей в параметрах: ident - наименование переменной, qn_val - значение.</li>
				
				</ul>

			</div>

		</myframe>
		-->

		<!--
		<myframe title="Scatter plot">

			<b-row>

				<b-col cols="6">

					<scatter_plot with_x_axis_title group_id="64704c14acf08363a33e64f5" x_attr_key="attrs.season" y_attr_key="attrs.rent_price"/>

				</b-col>

			</b-row>

		</myframe>
		-->

	</b-overlay>
	</div>

</template>

<script>

import api from "../api"
import myframe from "./widgets/frame"
import mymodal from "./widgets/modal"
// import scatter_plot from "./cadastral/cost_evaluations/setups/capitalization/scatter_plot"
import main_tree from "../api/main_tree"

export default
{
	components :
	{
		myframe,
		// scatter_plot,
		mymodal,
	},

	data()
	{
		return {

			formula : "exp(11.32240875+(-3.79873375977049*(1-(exp(-([city_center_a]/1408.28206620739)**0.145880185447225))))+(-0.196005560158583*(1-(exp(-([subway_a]))))))",
			formula_params : "[\n{\n\"ef_id\": \"65071\",\n\"ident\":\"city_center_a\",\n\"qn_val\": \"235.2675898685071\"\n},\n{\n\"ef_id\": \"65108\",\n\"ident\":\"subway_a\",\n\"qn_val\": \"138.9529535688953\"\n}\n]",

			procedure : null,
			session : null,
			pong : {},
			test_response : {},
			roles : [],
			wait : false,

			new_roles : [],

			roles_options: [
				{ text : "Сотрудник Росреестра. Чтение", value : "readonly" },
				{ text : "Сотрудник ГБУ. Настройка дерева групп", value : "group_tree" },
				{ text : "Сотрудник ГБУ. Группировка", value : "grouping" },
				{ text : "Сотрудник ГБУ. Настройка модели", value : "model" },
				{ text : "Сотрудник ГБУ. Определение КС", value : "cost" }
			],

			article : null,
			articles : [ "14", "16" ],

		}
	},

	mounted()
	{
		this.procedure = api.get_procedure(this)
		this.session = api.get_session(this)
		
		this.roles = window.localStorage.getItem("roles")

		api.call(this, "system", "procedure", {},
			response =>
			{
				this.article = response.data.article
			})
	},

	methods :
	{
		export_all()
		{
			api.call_long_operation(this, "Экспорт", "cadastral", "export", {}, api.open_response_url)
		},

		export_everything()
		{
			api.call_long_operation(this, "Экспорт реестров", "system", "export_everything", {}, api.open_response_url)
		},

		validation()
		{
			const query = { "and" : [ { "keys" : [ "current_version.attrs.cost" ], "operation" : "empty", "args" : [null], "reference" : null } ] }
			const route_data = this.$router.resolve(
			{
				name : "objects",
				query : { query_force : JSON.stringify(query), force : true },
			})

			window.open(route_data.href, "_blank")
		},

		calculate()
		{
			api.call(this, "cadastral_cost_evaluation", "calculate_formula", { formula : this.formula, params : this.formula_params },
				response =>
					this.$bvModal.msgBoxOk(
						"= " + response.result,
						{
							title : "Результат расчета",
							hideHeaderClose : false,
							centered : true
						})
				)
		},

		backup_restore()
		{
			this.wait = true

			api.call(this, "system", "backup_restore", {},
				() =>
				{
					this.wait = false

					this.$store.dispatch("logout", { self : this })
				})
		},

		ping()
		{
			api.call(this, "system", "ping", {}, response => { this.pong = response })
		},

		test()
		{
			api.call(this, "system", "test", {}, response => { this.test_response = response })
		},

		set_article(article)
		{
			api.call(this, "system", "set_article", { article : article }, () => {
				window.location.reload()
			})
		},

		// #####################################
		// Stated

		disable_stated()
		{
			this.$root.not_editable = !this.$root.not_editable
			main_tree.create(this).then(() => this.$emit("need_refresh"))
		},

		// #############################################################################

		download()
		{
			const url = "https://test.nspd.rosreestr.gov.ru/api/scv-support/v1/registers/file/463660/1.xlsx"

			api.download_file({ url : url })
		},

		// #####################################
		// Change roles

		reset()
		{
			this.new_roles = this.roles.split(",")
		},

		submit()
		{
			window.localStorage.removeItem("roles")
			window.localStorage.removeItem("session")
			let url = new URL(window.location.href)
			url.searchParams.set("token", this.new_roles.join('_'))
			window.location.replace(url.href)
		},

		toggle_readonly()
		{
			// TODO 4292
			const readonly = window.localStorage.getItem("readonly")
			window.localStorage.removeItem("roles")
			
			if (readonly === "true")
			{
				window.localStorage.removeItem("readonly")
			}
			else
			{
				window.localStorage.setItem("readonly", true)
			}

			window.location.reload()
		}
	},
}

</script>

